import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQG4v6iXZGEnIveXaLiVhQ7rFAsSBikXs",
  authDomain: "helveticcars-beb03.firebaseapp.com",
  projectId: "helveticcars-beb03",
  storageBucket: "helveticcars-beb03.firebasestorage.app",
  messagingSenderId: "268840294151",
  appId: "1:268840294151:web:6209b4a00a80168c7117a2",
  measurementId: "G-MCEG18XBMB",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
